export default __webpack_public_path__ + "static/media/geology-jupiter.93e4e021.png";